<app-slide-toggle-control
    (valueChange)="emit_valueChange($event)"
    [ariaLabel]="input_ariaLabel$$()"
    [control]="control$$()"
    [hideIcon]="input_hideIcon$$()"
    [label]="label$$()"
    [labelPosition]="input_labelPosition$$()"
    [readonly]="readonly$$()"
/>
